import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock-upgrade';

const teaserDateListItem = {
  cfg: {
    name: 'teaserDateListItem',
    dialogId: 'eventDialog',
    openBtnId: 'openEventDialog',
    closeBtnId: 'closeEventDialog',
  },

  toggleScrolling(containerEl, isStopped) {
    const drawer = containerEl.querySelector('[data-drawer]');

    if (containerEl && drawer) {
      if (isStopped) {
        disableBodyScroll(drawer);
      } else {
        enableBodyScroll(drawer);
      }
    }
  },

  updateUrl(newParamValue) {
    const url = new URL(window.location.href);
    if (newParamValue) {
      url.searchParams.set('termin-detail', newParamValue);
    } else {
      url.searchParams.delete('termin-detail');
    }
    window.history.pushState({}, '', url);
  },

  trapFocus(container) {
    const focusableElements = container.querySelectorAll(
      'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    const onTabPress = (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      }
    };

    container.addEventListener('keydown', onTabPress);
    return () => container.removeEventListener('keydown', onTabPress);
  },

  openModal(container, drawer, trigger = null) {
    if (!container || !drawer) return;

    this.lastTrigger = trigger;

    drawer.classList.remove('hidden');

    requestAnimationFrame(() => {
      container.setAttribute('data-state', 'open');
      drawer.setAttribute('data-state', 'open');

      const backdrop = container.querySelector('[data-backdrop]');
      if (backdrop) {
        backdrop.style.opacity = '0.15';
        backdrop.style.pointerEvents = 'auto';
      }

      this.toggleScrolling(container, true);

      const closeBtn = container.querySelector(`#${this.cfg.closeBtnId}--${container.id.split('--')[1]}`);
      if (closeBtn) {
        closeBtn.focus();
      }

      const removeFocusTrap = this.trapFocus(container);

      this.closeModal = () => {
        removeFocusTrap();
      };
    });
  },

  closeWithAnimation(container, drawer) {
    if (!container || !drawer) return;

    drawer.setAttribute('data-state', 'closed');
    container.setAttribute('data-state', 'closed');

    const backdrop = container.querySelector('[data-backdrop]');
    if (backdrop) {
      backdrop.style.opacity = '0';
      backdrop.style.pointerEvents = 'none';
    }

    setTimeout(() => {
      if (drawer.getAttribute('data-state') === 'closed') {
        drawer.classList.add('hidden');
      }

      this.toggleScrolling(container, false);
      this.updateUrl('');

      if (this.closeModal) {
        this.closeModal();
        this.closeModal = null;
      }

      if (this.lastTrigger && document.contains(this.lastTrigger)) {
        this.lastTrigger.focus();
      }
      this.lastTrigger = null;
    }, 500);
  },

  checkUrlForModal() {
    const id = new URLSearchParams(window.location.search).get('termin-detail');
    if (!id) return;

    const container = document.getElementById(`${this.cfg.dialogId}--${id}`);
    const drawer = container?.querySelector('[data-state]');

    if (container && drawer) {
      this.openModal(container, drawer);
    }
  },

  init() {
    // Bind close / backdrop handlers per dialog. This must iterate over the
    // dialogs themselves (not the open buttons), so deep-linked modals without a
    // matching open button (e.g. past events opened via ?termin-detail) can be closed too.
    const dialogs = document.querySelectorAll(`[id^="${this.cfg.dialogId}--"]`);

    dialogs.forEach((container) => {
      const id = container.id.split('--')[1];
      const drawer = container.querySelector('[data-state]');
      if (!drawer) return;

      const closeBtn = document.getElementById(`${this.cfg.closeBtnId}--${id}`);
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.closeWithAnimation(container, drawer));
      }

      container.addEventListener('click', (e) => {
        const rect = drawer.getBoundingClientRect();
        const clickedInside =
          rect.top <= e.clientY && e.clientY <= rect.bottom &&
          rect.left <= e.clientX && e.clientX <= rect.right;

        if (!clickedInside) {
          this.closeWithAnimation(container, drawer);
        }
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;

      const openContainer = document.querySelector(`[id^="${this.cfg.dialogId}--"][data-state="open"]`);
      if (!openContainer) return;

      const openDrawer = openContainer.querySelector('[data-state]');
      if (openDrawer) {
        this.closeWithAnimation(openContainer, openDrawer);
      }
    });

    // Bind open buttons separately (deep-linked past events don't have one).
    const openBtns = document.querySelectorAll(`[id^="${this.cfg.openBtnId}"]`);

    openBtns.forEach((btn) => {
      const id = btn.id.split('--')[1];
      const container = document.getElementById(`${this.cfg.dialogId}--${id}`);
      const drawer = container?.querySelector('[data-state]');

      if (btn && container && drawer) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.openModal(container, drawer, btn);
          this.updateUrl(id);
        });
      }
    });

    this.checkUrlForModal();
  },
};

export default teaserDateListItem;
